import React from 'react';

import { useRouteError } from "react-router-dom";

const ErrorPage = (props) => {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="main-block" id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}

export default ErrorPage;
